// CDN 全局默认配置项
export const CDN_URL = "https://static.zhihaoscm.cn";
